import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FavouritesWrapper, NumberSpan } from './styles';
import IconFont from '../../../components/shared/IconFont';
import ConfigManager from '../../../common/configManager/configManager';

class FavouritesButton extends Component {
  handleFavourites = () => {
    if (this.props.favouritesCounter > 0) {
      if (this.props.location.pathname !== ConfigManager.getRoute('favourites', process.env.REACT_APP_SITE)) {
        this.props.actions.push(ConfigManager.getRoute('favourites', process.env.REACT_APP_SITE));
      }
    }
  };

  render() {
    //const { isSelected } = this.state;
    const { favouritesCounter, isFavourite } = this.props;
    return (
      <FavouritesWrapper
        id="button-favourites"
        onClick={this.handleFavourites}
        isSelectedFavourites={isFavourite}
      >
        <IconFont
          className="icon-matchcenter-star"
          isSelectedFavourites={isFavourite}
          withCursor
          font={30}
          color="white"
        />
        <NumberSpan
          color="liveColor"
          size={14}
        >
          {favouritesCounter}
        </NumberSpan>
      </FavouritesWrapper >
    );
  }
}

FavouritesButton.propTypes = {
  favouritesCounter: PropTypes.number,
  actions: PropTypes.any,
  location: PropTypes.any,
  isFavourite: PropTypes.bool,
};

export default FavouritesButton;
